export default __webpack_public_path__ + "static/media/scheduleIcon.5cd1fb99.svg";